import { InjectionToken, ValueProvider } from '@angular/core';

export const MEASUREMENT_API_ORIGIN = new InjectionToken<string>('Measurement API Origin');
export const provideMeasurementApiOrigin = (origin: string): ValueProvider => ({
  provide: MEASUREMENT_API_ORIGIN,
  useValue: origin,
});
